import round from '@react/lib/helpers/round';

export function getCurrentAndPreviousYearData(data: {
  [key: string]: number;
}): { currentYearData: number; lastYearData: number } {
  const years = Object.keys(data)
    .map((year) => parseInt(year))
    .sort((a, b) => a - b);
  const lastYear = years[years.length - 2];
  const currentYear = years[years.length - 1];

  const lastYearData = data[lastYear.toString()];
  const currentYearData = data[currentYear.toString()];

  return { currentYearData, lastYearData };
}

export function computeYoYChange(data: { [key: string]: number }): number {
  const { currentYearData, lastYearData } = getCurrentAndPreviousYearData(data);

  const change = ((currentYearData - lastYearData) / lastYearData) * 100;

  return round(change, 2);
}
